import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { PurchaseItemsFormValues } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { Col, Form, FormInstance, Row, Select } from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<PurchaseItemsFormValues>;
}

const IcmsOperInterForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();

  const { purchase } = useReleasePurchaseFormContext();

  return (
    <Form form={form}>
      <Row gutter={[12, 12]}>
        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'percentFcp']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentIcmsFcp',
            })}
          >
            <InputDecimal max={100} disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'baseInterstateIcms']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.baseInterstateIcms',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'quotaIcmsUfDestination']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaIcmsUfDestination',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={12} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'quotaInterstateIcms']} //Validar qual o campo no endPoint
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms',
            })}
          >
            <Select
              allowClear
              style={{ width: '100' }}
              options={[
                {
                  value: 4,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms.zero',
                  }),
                },
                {
                  value: 7,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms.one',
                  }),
                },
                {
                  value: 12,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms.two',
                  }),
                },
              ]}
              disabled={purchase?.boschMigration}
            />
          </FloatingFormItem>
        </Col>

        <Col lg={12} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'percentProvisionalParticipation']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation',
            })}
          >
            <Select
              allowClear
              style={{ width: '100' }}
              options={[
                {
                  value: 40,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.zero',
                  }),
                },
                {
                  value: 60,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.one',
                  }),
                },
                {
                  value: 80,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.two',
                  }),
                },
                {
                  value: 100,
                  label: intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.three',
                  }),
                },
              ]}
              disabled={purchase?.boschMigration}
            />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueInterstateDestinationIcms']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.valueInterstateDestinationIcms',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueInterstateOriginIcms']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.valueInterstateOriginIcms',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueIcmsFcp']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.valueIcmsFcp',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default IcmsOperInterForm;
